import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-paiement-add',
  templateUrl: './paiement-add.component.html',
  styleUrls: ['./paiement-add.component.scss']
})
export class PaiementAddComponent implements OnInit {

  @Input() invoice: any;

  amount: number;
  date_paiement: any;

  constructor() { }

  ngOnInit() {
	this.amount = 0;
	this.date_paiement = new Date();
  	if (this.invoice) {
  		this.amount = this.invoice.tot.tvac;
  	}
  }

}
